import React from 'react';
import { Provider } from 'react-redux';

import { SentryErrorBoundary } from '@paragon/client-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import { store } from '../store';
import { darkTheme, lightTheme } from '../themes';
import RootComponent from './RootComponent';

interface Props {
  reduxStore: typeof store;
}

export default function ParagonServices(props: Props) {
  return (
    <React.StrictMode>
      <SentryErrorBoundary>
        <Provider store={props.reduxStore}>
          <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme}>
            <RootComponent />
          </ParagonThemeProvider>
        </Provider>
      </SentryErrorBoundary>
    </React.StrictMode>
  );
}
